<template>
  <!-- 售后评价页面 -->
  <div class="content">
    <div class="header">
      <van-nav-bar
        title="评价晒单"
        right-text="发布"
        left-arrow
        @click-left="$router.back()"
        @click-right="getProductInfo"
      />
    </div>
    <div class="center">
      <div class="evaluate">
        <div class="top">
          <img class="img1" :src="this.imgSrc" alt="" />
          <div class="commodityevaluation">
            <span>商品评价</span>
            <div class="evaluates">
              <van-rate
                color="#FC563A"
                size="0.373333rem"
                v-model="value"
                @change="onChange"
              />

              <span
                class="commodity"
                style="font-size:0.32rem;margin-left:0.16rem"
                >{{ commodity }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="textInfo describe">
        <van-field
          v-model="message"
          rows="2"
          autosize
          type="textarea"
          maxlength="500"
          placeholder="描述具体情况，有助于我们优化产品及服务"
          show-word-limit
        />
        <van-uploader
          :after-read="afterRead"
          v-model="fileList"
          :max-count="5"
          :max-size="30000 * 1024"
          :multiple="true"
          @oversize="onOversize"
          @delete="deleteImg"
          preview-size="2.133333rem"
        >
          <img src="../../assets/img/icon/组 10125@2x (1).png" alt="" />
        </van-uploader>
      </div>
      <div class="textInfo score">
        <p class="p1">
          服务满意度：<van-rate
            color="#FC563A"
            v-model="serve"
            @change="onChange2"
          /><span class="commodity">{{ commodity2 }}</span>
        </p>

        <p>
          物流满意度：<van-rate
            color="#FC563A"
            v-model="logistics"
            @change="onChange3"
          />
          <span class="commodity">{{ commodity3 }}</span>
        </p>
      </div>
    </div>
    <van-loading
      color="#1989fa"
      size="1rem"
      vertical
      v-show="LoadingShow"
      type="spinner"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      LoadingShow: false,
      // 商品评价
      value: 5,
      commodity: "非常好",
      // 服务评价
      serve: 5,
      commodity2: "非常好",
      // 物流评价
      logistics: 5,
      commodity3: "非常好",
      message: "",
      imgSrc: this.$route.query.img,
      id: this.$route.query.id,
      orderCode: this.$route.query.orderCode,
      checked: false,
      uploadImages: [],
      fileList: [],
    };
  },
  methods: {
    // 上传提交
    async getProductInfo() {
      if (this.message != "" && this.uploadImages != []) {
        this.LoadingShow = true;
        await this.$post({
          url: "/ogc/save",
          method: "post",
          dataType: "text",
          headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
          data: {
            // 用户id
            user_id: sessionStorage.getItem("EXCLUSIVE"),
            // 订单号
            relation_code: this.$route.query.orderCode,
            // 商品id
            goods_sn: this.$route.query.id,
            record_detail_id: this.$route.query.record_detail_id,
            // 评价内容
            remark: this.message,
            score: this.value,
            log_score: this.logistics,
            service_score: this.serve,
            // 图片文件
            file: this.uploadImages,
          },
        })
          .then((res) => {
            if (res.retCode == 200) {
              this.LoadingShow = false;
              this.$toast("评价完成!");
              this.$router.replace("/Sevaluation");
            } else {
              this.LoadingShow = false;
              this.$toast(res.message);
            }
          })
          .catch((err) => {
            this.LoadingShow = false;
            this.$toast("加载失败!");
          });
      } else {
        this.$toast("请输入评价内容或上传图片!");
      }
    },
    // 商品评价切换
    onChange(value) {
      switch (value) {
        case 1:
          return (this.commodity = "非常差");
        case 2:
          return (this.commodity = "差");
        case 3:
          return (this.commodity = "一般");
        case 4:
          return (this.commodity = "好");
        case 5:
          return (this.commodity = "非常好");
        default:
          break;
      }
    },
    // 服务评价切换
    onChange2(value) {
      switch (value) {
        case 1:
          return (this.commodity2 = "非常差");
        case 2:
          return (this.commodity2 = "差");
        case 3:
          return (this.commodity2 = "一般");
        case 4:
          return (this.commodity2 = "好");
        case 5:
          return (this.commodity2 = "非常好");
        default:
          break;
      }
    },
    // 物流评价切换
    onChange3(value) {
      switch (value) {
        case 1:
          return (this.commodity3 = "非常差");
        case 2:
          return (this.commodity3 = "差");
        case 3:
          return (this.commodity3 = "一般");
        case 4:
          return (this.commodity3 = "好");
        case 5:
          return (this.commodity3 = "非常好");
        default:
          break;
      }
    },
    // 上传图片
    async afterRead(file) {
      if (file instanceof Array && file.length) {
        file.forEach((item) => {
          this.uploadImages.push(item.content);
        });
      } else {
        this.uploadImages.push(file.content);
        sessionStorage.setItem("FILE",this.uploadImages.length)
      }
    },
    // 删除图片
    deleteImg(file, detail) {
      this.uploadImages = this.uploadImages.filter((item, index) => {
        return detail.index !== index;
      });
    },
    onOversize(file) {
      this.$toast("文件大小不能超过30M!");
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  height: 100%;
  background: #e8e8e8;
  .header {
    /deep/.van-icon-arrow-left::before {
      font-size: 0.533333rem;
      color: black;
    }
    /deep/.van-nav-bar__title {
      font-weight: 600;
    }
    /deep/.van-nav-bar__text {
      color: black;
    }
  }
  .center {
    border-radius: 0.08rem;
    padding: 0.2rem 0.373333rem 0 0.373333rem;
    .evaluate {
      background-color: #ffffff;
      .top {
        display: flex;
        align-items: center;
        margin: 0  0.4rem;
        padding: 0.2667rem 0;
        border-bottom: 0.026667rem solid #eeeeee;
        .img1 {
          width: 1.826667rem;
          height: auto;
        }
        .commodityevaluation {
          margin-left: 0.346667rem;
          span {
            color: #333333;
            font-size: 0.4rem;
            font-family: PingFang SC;
            font-weight: 400;
          }
          .evaluates {
            display: flex;
            align-items: center;
          }
        }
      }
    }
    .describe {
      padding-bottom: 0.5rem;
    }
    .textInfo {
      img {
        width: 2.133333rem;
        height: auto;
      }
      background-color: #fff;
      .van-cell:not(:last-child)::after {
        border-bottom: none;
      }
      .van-uploader {
        margin-left: 0.5rem;
      }
    }
    .anonymous {
      height: 1.2rem;
      overflow: hidden;
      .van-checkbox {
        margin-top: 0.3rem;
        margin-left: 0.5rem;
      }
    }
    .score {
      margin-top: 0.266667rem;
      border-radius: 0.08rem;
      p {
        height: 1.5rem;
        display: flex;
        align-items: center;
        font-family: PingFang SC;
        margin: 0 0.4rem;
        font-size: 0.373333rem;
      }
      .p1 {
        border-bottom: 0.026667rem solid #eeeeee;
      }
      span {
        margin-left: 0.4rem;
        font-size: 0.32rem;
        color: #f74b2e;
        font-size: 600;
        font-family: PingFang SC;
      }
    }
    .van-button {
      width: 4rem;
      border-radius: 0.5rem;
      margin-left: 50%;
      margin-top: 5rem;
      transform: translate(-50%);
    }
  }
  .van-loading {
    z-index: 99;
    position: fixed;
    top: 53%;
    left: 50%;
    transform: translate(-50%);
  }
}
</style>
